export class SearchRequestFacet {

	public field: string;

	public value: any;

	public clusivity: number;

}
